import React from 'react'
import { useState, useEffect } from 'react';
import ExercisePlayer from './components/ExercisePlayer';
import Tabs from './components/PlayerTabs';
import ExercisePlayerStress from './components/ExercisePlayerStress';

const CardExercise = ({exercise, l2, exerciseHandler}) => {
  const [showInfo] = useState(false);
  const [dia, setDia] = useState(null);
  const tabsData = [  
    {label: 'Oslo'},
    {label: 'Elverum'},
    {label: 'Trondheim'},
    {label: 'Malm'},
    {label: 'Stavanger'},
    {label: 'Bergen'},
    {label: 'Sandnessjøen'},
    {label: 'Tromsø'},
];
  const [tabs, setTabs] = useState(tabsData)   
  useEffect(()=>{
    if (l2 === "Norwegian") {
    const tabsData = [  
                        {label: 'Oslo'},
                        {label: 'Elverum'},
                        {label: 'Trondheim'},
                        {label: 'Malm'},
                        {label: 'Stavanger'},
                        {label: 'Bergen'},
                        {label: 'Sandnessjøen'},
                        {label: 'Tromsø'},
                    ];
    fetch(`${process.env.REACT_APP_API_URL}/norwegian/exercise/${exercise.id}`)
        .then(response=>response.json())
            .then(json=>{
                const grouped = json.dialects || {};
                var dialects = [];
                var tab_dialect = []
                for ( const dia of tabsData) {
                    var dialect = grouped[dia.label] || []

                    if (dialect.length > 4)
                    {
                        tab_dialect.push(dia)
                        dialects.push(dialect)
                    }
                    
                    
                }
                
                setTabs(tab_dialect) 
                setDia(tab_dialect[0])   

                 })
                }
             
},[exercise.id,l2]) 



    if(l2 === "Norwegian") {
      return <main className='exercise-shell'>
                  <div className='exercise-card flex flex-col md:flex-row'>
                    <aside className="border-b border-slate-200 p-4 md:w-48 md:border-b-0 md:border-r">
                      <p className="panel-heading mb-3">Dialect</p>
                          <Tabs 
                              clickHandler={(tab_index) =>
                                      {
                                          
                                          setDia(tabs[tab_index]);
                                        
                                    
                                      }
                              } 
                              tabsData={tabs} 
                          />
                    </aside>

                    <div className='min-w-0 flex-1'>
                    <div className={`grow
                  ${showInfo ? 'opacity-0 h-0' : 'opacity-100 h-full'} `}
                >
                    
                    {dia && <ExercisePlayer dialect={dia} id={exercise.id} l2={l2} exerciseHandler={exerciseHandler} />}
                    
                      </div>
                   
                </div>
                </div>
                </main>
    }
        return <main className='exercise-shell'>
            
        {/*The card*/}
        <div className="exercise-card animate__animated">
        
          
          {/* Main body */}
          <div className='flex flex-col h-full md:h-auto'>
          
              <div className={`flex flex-col
                    ${showInfo ? 'opacity-0 h-0' : 'opacity-100 h-full'} `}
                  >

                    {/* three cases -- two stress exercises and just exercise */}
                  
                    {exercise.Exercise_name === 'first-second-third' ? 
                    <ExercisePlayerStress numStress={3} id={exercise.id} l2={l2} exerciseHandler={exerciseHandler}/>
                    :
                    exercise.Exercise_name === 'first-second' ? 
                    <ExercisePlayerStress numStress={2} id={exercise.id} l2={l2} exerciseHandler={exerciseHandler} />
                    :
                    <ExercisePlayer id={exercise.id} l2={l2} exerciseHandler={exerciseHandler}/>
                    }
              <div/>    
          
            </div>
          </div>    
        </div>
      </main>

    
}
export default CardExercise;
